// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const UPDATEPROFILE = 'UPDATEPROFILE';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';